module.exports = __webpack_public_path__ + "img/cl_my_ticket_big.d8585469.png";